'use client';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../contexts/ApiContext';
import { useIsAuthed } from '../../../hooks/useIsAuthed';
import { queryKeys } from '../../../lib/queryClient';
import type {
  ClaimableAchievementRewards,
  ClaimAchievementRewardsResult,
} from '../../../services/generated/Api';

export type { ClaimableAchievementRewards, ClaimAchievementRewardsResult };

const CLAIMABLE_KEY = ['achievements', 'claimable'] as const;

export function useClaimableRewards() {
  const api = useApiClient();
  const isAuthed = useIsAuthed();
  return useQuery({
    queryKey: CLAIMABLE_KEY,
    queryFn: () => api.api.achievementsControllerGetClaimableRewards(),
    enabled: isAuthed,
    staleTime: 30_000,
  });
}

export function useClaimRewards() {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClaimAchievementRewardsResult, Error, void>({
    mutationFn: () => api.api.achievementsControllerClaimRewards(),
    onSettled: () => {
      qc.invalidateQueries({ queryKey: CLAIMABLE_KEY });
      qc.invalidateQueries({ queryKey: queryKeys.achievementsMine });
      qc.invalidateQueries({ queryKey: queryKeys.profile });
    },
  });
}
